type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  fillColor?: string;
};
const BrokenLinkIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 24 24',
    strokeColor = '#F2D093',
    fillColor = 'none',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fillColor}
    >
      {/* Left link half — C shape opening right */}
      <path
        d="M9 7H7a3 3 0 0 0 0 6h2"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Middle broken piece — short segment */}
      <path
        d="M11.5 10h1"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Right link half — C shape opening left */}
      <path
        d="M15 7h2a3 3 0 0 1 0 6h-2"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BrokenLinkIcon;
